// src/javascript/utils/showThreejsJourney.js
import gsap from 'gsap'
import ScoreManager from '../Utils/ScoreManager.js'


export default function showThreejsJourney() {
    const container = document.querySelector('.js-threejs-journey')
    if (!container) return

    const messages = [...container.querySelectorAll('.js-message')]
    const yes = container.querySelector('.js-yes')
    const no = container.querySelector('.js-no')

    // Reset Zustand
    messages.forEach(msg => msg.classList.remove('is-visible'))
    container.classList.remove('is-hover-no', 'is-hover-yes')
    container.classList.add('is-hover-none', 'is-active')

    let step = 0

    const showStep = () => {
        if (step >= messages.length) return

        const current = messages[step]
        current.classList.add('is-visible')
    
        // Verschiebe sichtbare Nachrichten nach oben
        let offset = 0
        for (let i = 0; i <= step; i++) {
            const el = messages[i]
            el.style.transform = `translateY(${-offset}px)`
            offset += el.offsetHeight - 25 // Abstand zw. Nachrichten
        }
    
        step++
        if (step < messages.length) {
            setTimeout(showStep, 2000)
        }
    }

    // Buttons
    if (yes) {
        yes.addEventListener('click', () => {
            container.classList.remove('is-active')
            
        })
        ScoreManager.add(1)
    }

    if (no) {
        no.addEventListener('click', () => {
           
                // Alle vorherigen Nachrichten verbergen
                messages.forEach(msg => msg.classList.remove('is-visible'))
        
                // Nur letzte Nachricht anzeigen
                const last = messages[messages.length - 1]
                last.classList.add('is-visible')
                last.style.transform = 'translateY(0)'
        
                // Optional: Container bleibt sichtbar
                container.classList.add('is-active')
            

            container.classList.remove('is-active')
        }, 5000)
    }

    // Start anzeigen
    showStep()
}
